export default __webpack_public_path__ + "media/images/fancybox/fancy_title_right-ce0cb6d5b71e323b0250bae86ef8438f.png";